<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Partecipanti',
      link: '/partecipanti'
    }, {
      label: 'Gestisci Codici Rifiuto'
    }]"
  />

  <form autocomplete="off">
    <div
      v-for="wasteCode in wasteCodes"
      :key="'company-waste-code-' + wasteCode.uuid"
    >
      <InputBoolean
        v-model="form[wasteCode.uuid]"
        :error-fields="[]"
        :name="wasteCode.code"
        :submitted="false"
      >
        {{ wasteCode.code }}
      </InputBoolean>
    </div>
    <SubmitButtons
      mode="update"
      :pending="pending"
      :update="update"
    />
  </form>
</template>

<script setup>
import { reactive,ref } from 'vue'
import { useRouter } from 'vue-router';

import InputBoolean from '@/components/form/InputBoolean.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios';
import { useNotificationsStore } from '@/stores/notifications';

const props = defineProps({
  id: {
    required: true,
    type: String
  }
})

const axios = useAxios()
const notificationStore = useNotificationsStore()
const router = useRouter()

const pending = ref(false);

const wasteCodeResp = await axios.get('/waste-code/list');
const wasteCodes = ref(wasteCodeResp.data)

const resp = await axios.get('/company/' + props.id);
const companyWasteCodes = resp.data.wasteCodes

const form = reactive(wasteCodes.value.reduce((carry, wasteCode) => {
  carry[wasteCode.uuid] = companyWasteCodes.includes(wasteCode.uuid)
  return carry;
}, {}))

const update = async () => {
  pending.value = true;
  try {
    await axios.post('/company/' + props.id + '/waste-code', { uuids: Object.keys(form).filter((key) => form[key]) })

    notificationStore.pushSuccess('Partecipante aggiornato con successo');
    router.push('/partecipanti');
  } catch (e) {
    pending.value = false;
    throw e
  }
}

</script>